export default "eeabbccb2bb5772d.svg"